<template>
  <a-modal title="Filters" width="600px" :visible="visible" @cancel="cancel" :destroy-on-close="true" v-if="visible">
    <div class="grid">
      <b class="col-4">Start Date</b>
      <a-date-picker
        class="col-8"
        format="MM/DD/YYYY"
        v-model="filters.start"
        valueFormat="YYYY-MM-DD"
        placeholder="Start Date"
        @change="handleStartDateChange('start', 'end')"
      />

      <b class="col-4">End Date</b>
      <a-date-picker
        class="col-8"
        format="MM/DD/YYYY"
        v-model="filters.end"
        valueFormat="YYYY-MM-DD"
        placeholder="End Date"
        ref="endDatePicker"
        @change="handleEndDateChange('start', 'end')"
        :open="isEndDatePickerOpen"
        :default-picker-value="getEndDateDefaultPickerValue('start')"
        @openChange="handleEndDateOpenChange"
      />

      <b class="col-4">Statuses</b>
      <custom-select
        class="col-8"
        :multiple="true"
        :value.sync="filters.statuses"
        placeholder="Statuses"
        :options="statuses"
        name="name"
        optionKey="id"
      />

      <b class="col-4">Type</b>
      <custom-select
        class="col-8"
        :multiple="true"
        :value.sync="filters.types"
        placeholder="Type"
        :options="types"
        name="name"
        optionKey="id"
      />
    </div>
    <template slot="footer">
      <div class="flex justify-content-end">
        <a-button type="danger" :disabled="isEmptyFilters" @click="reset"> Reset </a-button>
        <a-button type="primary" @click="apply"> Apply </a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import CustomSelect from '@/components/ui/custom-select.vue'
import { TIME_OFF_STATUS, TIME_OFF_TYPE } from '@/store/modules/time-off/constant'
import { Modal, Button, DatePicker } from 'ant-design-vue'
import { deepCopy } from '@/utils/deep-copy'
import LinkedDateFilterMixin from '@/mixins/linkedDateFilterMixin'

const filtersBaseState = Object.freeze({
  types: undefined,
  statuses: undefined,
  end: undefined,
  start: undefined
})

export default {
  mixins: [LinkedDateFilterMixin],
  components: {
    'a-modal': Modal,
    'a-button': Button,
    'a-date-picker': DatePicker,
    'custom-select': CustomSelect
  },
  data() {
    return {
      filters: deepCopy(filtersBaseState),
      types: Object.entries(TIME_OFF_TYPE)
        .map(([key, value]) => ({
          id: key,
          name: value.title
        }))
        .filter(item => item.id !== 3),
      statuses: Object.entries(TIME_OFF_STATUS).map(([key, value]) => ({
        id: key,
        name: value.title
      }))
    }
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    currentFilters: {
      type: Object,
      required: true
    }
  },
  computed: {
    isEmptyFilters() {
      return JSON.stringify(filtersBaseState) === JSON.stringify(this.filters)
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) {
          this.filters = {
            ...filtersBaseState,
            ...deepCopy(this.currentFilters)
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    reset() {
      if (this.isEmptyFilters) {
        this.cancel()
      } else {
        this.filters = deepCopy(filtersBaseState)
        this.$emit('update:currentFilters', this.filters)
      }
    },

    cancel() {
      this.$emit('update:visible', false)
    },

    apply() {
      this.cancel()
      this.$emit('update:currentFilters', this.filters)
    }
  }
}
</script>

<style scoped></style>
